// extracted by mini-css-extract-plugin
export var icon = "_4h-1";
export var subtext = "_4h-0";